export function convertDateFormat(dateStr) {
  const date = new Date(dateStr)
  const options = { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }
  const formattedDate = date.toLocaleString('en-US', options)
  return formattedDate.replace(',', '-').replace(' ', ' ')
}

export function convertDateFormat2(dateStr) {
  const date = new Date(dateStr)

  if (isNaN(date.getTime())) {
    return 'Invalid date'
  }

  const options = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }

  try {
    const datePart = date.toLocaleDateString('en-US', options)
    return `${datePart}`
  } catch (error) {
    throw new Error('Error formatting date: ' + error.message)
  }
}

export const DOMAIN = process.env.REACT_APP_DOMAIN || ''
export const bookingDetails = (orderId, params) => `/booking-details/${orderId}${params || ''}`

export function debounce(func, immediate) {
  let timeout
  return function executedFunction() {
    const context = this
    const args = arguments

    const later = () => {
      timeout = null
      if (!immediate) func.apply(context, args)
    }

    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, 500)
    if (callNow) func.apply(context, args)
  }
}
